import { Component } from "@angular/core";
import { ConfigService } from '../../providers/dbservice/configservice';
import { HttpClient } from '@angular/common/http';
import { NavController, AlertController, Popover, NavParams } from "ionic-angular";
import { Document } from "../../models/interfaces/document.model";
import { Location } from "@angular/common";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClientModule } from '@angular/common/http';
@Component({
  selector: "page-upload",
  templateUrl: "upload.html",
})
export class UploadPage {
 
  private uploadForm: FormGroup;
  private hl_runno: String;
  private filename: String;
  private document$: any;
  private styleName: string ="";
  file_data: any = '';
  controllerUploadURI;
  constructor(private configService: ConfigService, public navParams: NavParams, private db: DbserviceProvider, public alertCtrl: AlertController, public navCtrl: NavController, private location: Location, private formBuilder: FormBuilder, public http: HttpClient) {
    console.log("UploadPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.controllerUploadURI = configService.getConfig('UPLOAD_URL');
    this.hl_runno = this.navParams.get("hlrunno");

    this.uploadForm = this.formBuilder.group({
      "hl_id": [this.navParams.get("hlrunno")],
      "dc_id": [878],
      "do_filename": ["", Validators.required],
    });

  }
  private ionViewWillEnter() {
    console.log("UploadPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("UploadPage onInitPage");

    this.document$ = this.db.dbCol({ "action": "select", "mapObject": "document", "sqlExtended": " where hl_id='" + this.navParams.get("hlrunno") + "'" });
  }
  private deleteDocument(document: Document ) {
    console.log("UploadPage deleteDocument");
    this.db.dbCol({ "action": "dml", "mapObject": "dml", "query": "DELETE FROM document WHERE do_id='" + document.do_id + "'" })
      .subscribe((doc) => {
        this.document$ = this.db.dbCol({ "action": "select", "mapObject": "document", "sqlExtended": " where hl_id='" + this.navParams.get("hlrunno") + "'" });
      });
    this.db.dbCol({
      "action": "deletedoc", "mapObject": document.do_filename 
    })
      .subscribe((result) => {
      });

  }

  fileChange(index, event) {
    const fileList: FileList = event.target.files;
    //check whether file is selected or not
    if (fileList.length > 0) {

      const file = fileList[0];
      //get file information such as name, size and type
      this.filename = file.name;

      //max file size is 20 mb
      if ((file.size / 1048576) <= 20) {
        let formData = new FormData();
        let info = { id: 2, name: 'raja' }
        formData.append('file', file, file.name);
        formData.append('id', '2');
        formData.append('tz', new Date().toISOString())
        formData.append('update', '2')
        formData.append('info', JSON.stringify(info))
        this.file_data = formData

      } else {

      }

    }

  }

  private goback() {
    console.log("UploadPage goback");
    this.navCtrl.pop();
  }

  private uploadFile() {
    console.log("UploadPage uploadFile");

    this.http.post(this.controllerUploadURI, this.file_data)
      .subscribe(res => {
        //send success response
      }, (err) => {
        //send error response
      });
    const files = { ...this.uploadForm.value, "do_filename": this.filename };

    this.db.dbCol({ "action": "insert", "mapObject": "document", ...files })
      .subscribe((ret) => {
        this.document$ = this.db.dbCol({ "action": "select", "mapObject": "document", "sqlExtended": " where hl_id='" + this.navParams.get("hlrunno") + "'" });
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/upload/upload.ts